import { Empty, Skeleton, Modal as AModal } from "antd";
import { useEffect, useState } from "react";
import { Divider, Modal } from "rsuite";
import { char, number } from "../../../utils";
import moment from "moment";
import { gatewayCRUD } from "../../../actions/gateway";
import { selector } from "../../../api";
import { useNotification } from "../../../utils/notification";
import { stubFalse } from "lodash";

export const ClearanceData = (props) => {
  const { open, setOpen, index, setIndex, data } = props;
  const openNotification = useNotification();
  const [loading, setLoading] = useState(false);
  const user = selector.User();

  const handleApprove = () => {
    setLoading(true);
    setTimeout(() => {
      const dataApprove = {
        approved_by: user.id,
        comment: "",
      };
      gatewayCRUD
        .approveInvoiceClearance(data?.clearance_id, dataApprove)
        .then(() => {
          openNotification(
            "success",
            "Success",
            "Thank you....! invoice clearance has been approved",
          );
          setIndex(index + 1);
          setOpen(false);
        })
        .catch((error) => {
          const responseData = error?.response?.data;
          let errorMessage = "Something went wrong. Please try again.";

          if (typeof responseData === "string") errorMessage = responseData;
          else if (responseData?.error) errorMessage = responseData.error;
          else if (responseData?.detail) errorMessage = responseData.detail;
          else if (responseData?.message) errorMessage = responseData.message;
          else if (typeof responseData === "object") {
            const firstKey = Object.keys(responseData)[0];
            const firstError = responseData[firstKey];
            if (Array.isArray(firstError)) errorMessage = firstError[0];
          }

          openNotification("error", "Error", errorMessage);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 500);
  };

  const handleReject = () => {
    setLoading(true);
    setTimeout(() => {
      const dataApprove = {
        rejected_by: user.id,
        comment: "",
      };
      gatewayCRUD
        .rejectInvoiceClearance(data?.clearance_id, dataApprove)
        .then(() => {
          openNotification(
            "success",
            "Success",
            "Thank you....! invoice clearance has been rejected",
          );
          setIndex(index + 1);
          setOpen(stubFalse);
        })
        .catch((error) => {
          const responseData = error?.response?.data;
          let errorMessage = "Something went wrong. Please try again.";

          if (typeof responseData === "string") errorMessage = responseData;
          else if (responseData?.error) errorMessage = responseData.error;
          else if (responseData?.detail) errorMessage = responseData.detail;
          else if (responseData?.message) errorMessage = responseData.message;
          else if (typeof responseData === "object") {
            const firstKey = Object.keys(responseData)[0];
            const firstError = responseData[firstKey];
            if (Array.isArray(firstError)) errorMessage = firstError[0];
          }

          openNotification("error", "Error", errorMessage);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 500);
  };

  const handleApproveConfirm = () => {
    AModal.confirm({
      title: "Confirm Approval",
      content: "Are you sure you want to approve this payment clearance?",
      okText: "Yes, Approve",
      okType: "primary",
      cancelText: "Cancel",
      onOk: async () => {
        handleApprove();
      },
    });
  };

  const handleRejectConfirm = () => {
    AModal.confirm({
      title: "Confirm Rejection",
      content: "Are you sure you want to reject this payment clearance?",
      okText: "Yes, Reject",
      okType: "danger",
      cancelText: "Cancel",
      onOk: async () => {
        handleReject();
      },
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (data) {
        setLoading(false);
      } else {
        setLoading(false);
      }
    }, 10000); // wait 2 seconds

    return () => clearTimeout(timer);
  }, [data]);

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
          setIndex(index + 1);
        }}
        size="lg"
        backdrop={"static"}
      >
        <Modal.Header>
          <Modal.Title>Clearance Data</Modal.Title>
        </Modal.Header>
        <Divider />
        <Modal.Body>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="card shadow-sm">
                  <div className="card-body">
                    {loading ? (
                      <Skeleton active />
                    ) : !data ? (
                      <Empty description="No clearance details available" />
                    ) : (
                      <>
                        <table className="table table-bordered">
                          <tbody>
                            <tr>
                              <th>Payer Name</th>
                              <td>{char.toUpperCase(data.payer_name)}</td>
                            </tr>

                            <tr>
                              <th>Identity Number</th>
                              <td>{char.toUpperCase(data.identity_number)}</td>
                            </tr>

                            <tr>
                              <th>Control Number</th>
                              <td>{char.toUpperCase(data.control_number)}</td>
                            </tr>

                            <tr>
                              <th>Reference</th>
                              <td>{char.toUpperCase(data.reference)}</td>
                            </tr>

                            <tr>
                              <th>Amount</th>
                              <td>
                                {number.fNumberDoublePoint(data.amount)} TZS
                              </td>
                            </tr>

                            <tr>
                              <th>Payment Date</th>
                              <td>
                                {moment(data.date).format("MMM, DD YYYY")}
                              </td>
                            </tr>

                            <tr>
                              <th>Reason</th>
                              <td>{data.reason}</td>
                            </tr>
                          </tbody>
                        </table>

                        <div className="d-flex gap-2 mt-3">
                          <button
                            className="btn btn-success"
                            onClick={handleApproveConfirm}
                            disabled={loading}
                          >
                            <i className="bi bi-check-circle me-2"></i>
                            Approve
                          </button>

                          <button
                            className="btn btn-danger"
                            onClick={handleRejectConfirm}
                            disabled={loading}
                          >
                            <i className="bi bi-x-circle me-2"></i>
                            Reject
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Divider style={{ marginTop: -10 }} />
        <Modal.Footer>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 col-sm-12 d-flex justify-content-start"></div>
              <div className="col-md-6 col-sm-12 d-flex justify-content-end">
                <button
                  onClick={() => {
                    setOpen(false);
                    setIndex(index + 1);
                  }}
                  disabled={loading}
                  type="button"
                  className="btn btn-soft-danger btn-label waves-effect waves-light rounded-pill me-3"
                >
                  <i class="bi bi-x-circle label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
